import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Oval } from "react-loader-spinner"

import { getGoogleUserChatUri } from '../services/api/googleChat'

import { getMobileNumber } from '../utils'

import googleChatIcon from "../images/google_chat_icon.png"
import whatsappIcon from "../images/whatsapp.png"


const PMUserName = ({ userName, userId }) => {
	const [isLoading, setIsLoading] = useState(false)

    const op = useRef(null)
    const hideTimeoutRef = useRef(null)

    const companyUsers = useSelector(state => state.userDetails.companyDetails.companyUsers)
    const userDetails = useSelector(state => state.userDetails)
    const companyBranches = userDetails.PMCompanyDetails.companyBranches
    const companyRoles = userDetails.PMCompanyDetails.companyRoles
    const loggedInUserId = useSelector(state => state.userDetails.userId)

    const renderUserRoles = () => {
        const relatedUser = companyUsers.find(eachUser => eachUser.userId === userId)
        if (!relatedUser) {
			return null
		}

        let phoneNumber = getMobileNumber(relatedUser.phoneNumber)
        const emailId = relatedUser.emailId

        const handleSendWhatsAppMessage = async () => {
            try {
                window.open(`https://wa.me/${phoneNumber}`, '_blank')
            } catch (error) {
                console.error("Error sending WhatsApp message:", error)
            }
        }

        const handleGetGoogleUserChatUri = async () => {
			setIsLoading(true)
            const response = await getGoogleUserChatUri({ userId: loggedInUserId, emailId })
			setIsLoading(false)

            if (response.failure) {
                if (window.confirm("Chat with the user doesn't exist.\nMessage copied. Open chat manually and paste the message.")) {
                    window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
                }
            } else {
                window.open(response.data, '_blank')
            }
        }

        const displayUserRoles = relatedUser.userRoles.map(eachUserRole => {
            const relatedBranch = companyBranches.find(eachBranch => eachBranch.branchId === eachUserRole.branchId)
            const relatedCompanyRole = companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === eachUserRole.companyRoleId)

			if(relatedCompanyRole && eachUserRole.statusId === 1){
				return {
					...eachUserRole,
					branchName: relatedBranch?.branchName || "ALL",
					companyRoleName: relatedCompanyRole.companyRoleName
				}
			}
			return null
        }).filter(Boolean)

        return (
            <div>
                {displayUserRoles.map((eachUserRole, index) => (
                    <p key={`role-${index}`} style={{ margin: 0, fontSize: "12px" }}>
                        <span className='font-semibold'>{eachUserRole.companyRoleName}</span> -{" "}
                        {eachUserRole.branchName}
                    </p>
                ))}
                <div style={{ fontSize: "12px" }}>
                    <div className='flex align-items-center mt-1'>{emailId}
						{ isLoading ?
						 		<Oval
									height={20}
									width={20}
									color="#00baac"
									visible={isLoading}
									ariaLabel='oval-loading'
									secondaryColor="#a4a7a6"
								/>
                        	:
								<img className='ml-2' src={googleChatIcon} alt="" style={{ width: "15px", height: "15px", cursor: "pointer" }} onClick={handleGetGoogleUserChatUri} />
						}
                    </div>
                    <div className='flex align-items-center mt-1'>{relatedUser.phoneNumber}
                        <img className='ml-2' src={whatsappIcon} alt="" style={{ width: "15px", height: "15px", cursor: "pointer" }} onClick={handleSendWhatsAppMessage} />
                    </div>
                </div>
            </div>
        )
    }

    const handleMouseEnter = (e) => {
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current) 
        op.current.show(e)
    }

    const handleMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => {
            op.current?.hide()
        }, 200) 
    }

    const handlePanelMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => {
            op.current?.hide()
        }, 10) 
    }
 
    return (
        <>
            <span
                id={`username-${userId}`}
                className='pm-user-name'
                onClick={(e) => op.current.toggle(e)}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {userName}
            </span>
            <OverlayPanel
                className='user-name-overlay-panel'
                target={`#username-${userId}`}
                // target={op.current}
                ref={op}
                onMouseEnter={() => clearTimeout(hideTimeoutRef.current)}
                onMouseLeave={handlePanelMouseLeave}
            >
                {renderUserRoles()}
            </OverlayPanel>
        </>
    )
} 

export default PMUserName
